export default __webpack_public_path__ + "static/media/citadel_default.382bb3b9.jpg";